import { render, staticRenderFns } from "./Paymanage.vue?vue&type=template&id=6678d5dc&"
import script from "./Paymanage.vue?vue&type=script&lang=js&"
export * from "./Paymanage.vue?vue&type=script&lang=js&"
import style0 from "./Paymanage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports